module.exports = __webpack_public_path__ + "img/reena.83b89017.jpg";